import { render, staticRenderFns } from "./ImportFromImage.vue?vue&type=template&id=0ccad666&scoped=true"
import script from "./ImportFromImage.vue?vue&type=script&lang=js"
export * from "./ImportFromImage.vue?vue&type=script&lang=js"
import style0 from "./ImportFromImage.vue?vue&type=style&index=0&id=0ccad666&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccad666",
  null
  
)

export default component.exports